unable to read source [project]/node_modules/@zxing/src/common/navigator-utils.ts